import { MenuItemDefinition } from '@neos/core'

export const menuItems: Record<string, MenuItemDefinition> = {
  AssignPermission: {
    to: 'AssignPermissionToRolesListUI',
  },
  CustomUIViewListUI: {
    icon: 'createCustomView',
    to: 'CustomUIViewListUI',
  },
  NotificationTracking: {
    to: 'PiNotificationTrackingUi',
  },
  Organisms: {
    to: 'PiOrganismsUI',
  },
  Permission: {
    to: 'PermissionUI',
  },
  Permissions: {
    to: 'AssignPermissionToRolesListUI',
  },
  PermissionsLocal: {
    to: 'AssignPermissionToRolesListUI',
  },
  PiBillableNotificationsCount: {
    to: 'PiBillableNotificationsCountUI',
  },
  PiGlobalParam: {
    to: 'PiGlobalParamUI',
  },
  PiNotification: {
    to: 'PiNotificationUI',
  },
  Roles: {
    to: 'UserAccountUserRoleEntityUI',
  },
  UserAccount: {
    to: 'UserAccountListUI',
  },
  UserAccountUserRole: {
    to: 'UserAccountUserRoleUI',
  },
  UserList: {
    to: 'UserAccountListUI',
  },
  UserListLocal: {
    to: 'UserAccountListUI',
  },
  UserOrganisms: {
    to: 'PiUserToOrganismsUI',
  },
  UserSettings: {
    to: 'UserSettingsUI',
  }
}